import store from "@/store/index";
import axios from 'axios'
import {getNavIdByCode} from '@/api';

// 获取数据字典
export const getKeyValues = (keys) => {
  return store.dispatch("GET_KEY_VALUES", keys);
};


var getNavId = async function(code) {
    let res = await getNavIdByCode(code);
    let navList = res.data.data;
    var navObj = {};

    navList.forEach(function (val) {
        navObj[val.code] = val.id;
    })
    return navObj[code];
}

var getFirstPic = function(str) {
    let data = '';
    str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/, (match, capture) => {
      data = capture;
    })
    return data;
}

/**
 * 校验电话（手机号）
 */
export function validateCellPhone(rule, value, callback) {
    const reg = /^1[3456789]\d{9}$/;
    if (value && !reg.test(value)) {
      callback(new Error("请输入正确的手机号码"));
    } else {
      callback();
    }
}
export const formatDate = (value)  => {
  var dt = new Date(value);
  let year = dt.getFullYear();
  let month = (dt.getMonth() + 1).toString().padStart(2,'0');
  let date = dt.getDate().toString().padStart(2,'0');
  let hour = dt.getHours().toString().padStart(2,'0');
  let minute = dt.getMinutes().toString().padStart(2,'0');
  let second = dt.getSeconds().toString().padStart(2,'0');
  return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
}

// 校验表单
export const validateForm = (form) => {
    let flag = true;
    form.validate((valid) => {
      flag = valid;
    });
    return flag;
};
// 校验密码
export const validatePwd = (rule, value, callback) => {
  const regex =
    /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[~!@#$%^&*])[\da-zA-Z~!@#$%^&*]{10,32}$/;
  if (!regex.test(value)) {
    callback(
      new Error(
        "请输入数字字母特殊字符(~!@#$%^&*)三种的组合，且长度在10-32个字符。"
      )
    );
  } else {
    callback();
  }
};

export function checkArray(val) {
  return Object.prototype.toString.call(val) === "[object Array]";
}
// 身份证检验
export const isIdcard = (idno) => {
    if (idno.length > 18) {
        return false;
    }
    // 六位地区编码 region
    const region = "((1[1-5]|2[1-3]|3[1-7]|4[1-6]|5[0-4]|6[1-5]|8[1-3])\\d{4})";
    // 四位年份 year
    const year = "((18|19|20|21)\\d{2})";
    // 两位月份 month
    const month = "(0[1-9]|1[0-2])";
    // 两位日期 date
    const date = "(0[1-9]|[12]\\d|3[01])";
    // 末尾四位编号 code
    const code = "(\\d{3}([0-9xX]))";

    const regex = region + year + month + date + code;
    return new RegExp(regex).test(idno);
};

const navMap = {
  "newsList": {
    name: "newsList",
    text: "新闻中心",
    path: "/news/newsList"
  },
  "searchNewsList": {
    name: "newsList",
    text: "新闻搜索",
    path: "/searchNews/searchNewList"
  },
  "searchNoticeList": {
    name: "noticeList",
    text: "公告搜索",
    path: "/searchNotices/noticeList"
  },
  "searchPurchaseCorrectList": {
    name: "noticeList",
    text: "更正公示搜索",
    path: "/searchPurchaseNotice/correctList"
  },
  "searchPurchaseResultList": {
    name: "noticeList",
    text: "结果公示搜索",
    path: "/searchPurchaseNotice/resultList"
  },
  "itInfo": {
    name: "itInfo",
    text: "行业动态",
    path: "/news/itInfo"
  },
  "announcement": {
    name: "announcement",
    text: "通知公告",
    path: "/news/announcement"
  },
  "purchase": {
    name: "purchase",
    text: "采购公告",
    path: "/news/purchase"
  },
  "partyBuild": {
    name: "partyBuild",
    text: "党建工作",
    path: "/party/partyBuild"
  },
  "supervise": {
    name: "supervise",
    text: "纪检工作",
    path: "/party/supervise"
  },
  "groupWork": {
    name: "groupWork",
    text: "群团工作",
    path: "/party/groupWork"
  },
  "Products": {
    name: "Products",
    text: "项目展示",
    path: "/Products"
  },
  "purchaseNoticeTender": {
    name: "purchaseTender",
    text: "采购公示",
    path: "/purchaseManage/tender"
  },
  "purchaseNoticeFail": {
    name: "purchaseFail",
    text: "更正公示",
    path: "/purchaseManage/fail"
  },
  "purchaseNoticeSuccess": {
    name: "purchaseSuccess",
    text: "结果公示",
    path: "/purchaseManage/success"
  },
  "mySignUpList": {
    name: "mySignUpList",
    text: "我的报名",
    path: "/my/mySignUp"
  },
};
// 格式化get请求参数
export const initGetParams = (params) => {
  var arr = [];
  for (const key in params) {
    if (
      params[key] !== null &&
      params[key] !== "" &&
      params[key] !== undefined
    ) {
      // 数组
      if (Array.isArray(params[key])) {
        params[key].forEach((val) => {
          arr.push(`${key}=${val}`);
        });
      } else {
        arr.push(`${key}=${params[key]}`);
      }
    }
  }
  return arr.join("&");
};


export default {
    getNavId,
    getFirstPic,
  navMap,
  initGetParams
}

// 导出
export const downloadFile = (
  url,
  method,
  filename,
  loading,
  errorMsg,
  fileType,
  data,
) => {
  axios({
    url,
    method,
    data,
    responseType: 'blob',
    baseURL: process.env.VUE_APP_BASE_API,
    headers: {
      token: store.state.system.token,
    },
  })
    .then((res) => {
      if (res.data.size <= 0) {
        baseMessage('暂无导出数据', 'warning')
        loading.close()
        return
      }
      loading.close()
      if (res.status === 200 && res.data) {
        const blob = new Blob([res.data])
        const fileName = `${filename}${fileType}`
        if ('download' in document.createElement('a')) {
          if (window.FileReader) {
            var reader = new FileReader()
            reader.readAsDataURL(blob) // 转换为base64，可以直接放入a标签href
            reader.onload = function (e) {
              var elink = document.createElement('a') // 转换完成，创建一个a标签用于下载
              elink.download = fileName
              elink.href = e.target.result
              document.body.appendChild(elink) // 修复firefox中无法触发click
              elink.click()
              document.body.removeChild(elink)
            }
          } else {
            const elink = document.createElement('a')
            elink.download = fileName
            elink.style.display = 'none'
            elink.href = window.URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href)
            document.body.removeChild(elink)
          }
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      }
    })
    .catch(() => {
      baseMessage(errorMsg, 'error')
      loading.close()
    })
}